import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Nusrath Jahan Happy',
    title: "Front End Developer",
    desciption:"Have experiences of building Web applications with JavaScript, Reactjs, Nodejs and some other cool libraries.",
    image: 'https://i.postimg.cc/NMbz27XN/nusrath.jpg',
    resumePdf: resume
}
